
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.546 8a.723.723 0 01-.69-.508l-1.642-5.274c-.211-.678-1.17-.678-1.381 0L7.191 7.492A.723.723 0 016.5 8H1.577c-.708 0-.994.912-.413 1.317l4.006 2.789c.26.18.372.51.276.812l-1.571 4.95c-.212.669.556 1.218 1.12.8l4.097-3.039a.723.723 0 01.861 0l4.109 3.042c.563.417 1.331-.132 1.12-.8l-1.573-4.954a.723.723 0 01.276-.812l4-2.789c.58-.405.294-1.316-.414-1.316h-4.926z","stroke":"#748190","stroke-width":"1.446","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    